<template>
	<div class="change-password layout-column layout-hv-center">
		<h1 class="color-black-gray1">更改密碼</h1>
		<el-form :model="ruleForm" :rules="rules" ref="changePwdForm" status-icon>
			<el-form-item prop="password">
				<el-input type="password" v-model="ruleForm.password" placeholder="請輸入新密碼（至少8字元）"></el-input>
			</el-form-item>
			<el-form-item prop="passwordConfirm">
				<el-input type="password" v-model="ruleForm.passwordConfirm" placeholder="再次輸入新密碼" @keydown.native.enter.prevent="changePasswordSumbit"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="info" @click="changePasswordSumbit">確認</el-button>
			</el-form-item>
		</el-form>
		<el-dialog :visible.sync="visibleSuccess" width="30%" :before-close="handleClose">
			<div class="description layout-row layout-hv-center">更改成功，請重新登入</div>
			<div slot="footer" class="dialog-footer layout-row layout-hv-center">
				<div class="success-button button-tp color-white bg-green1" @click="handleClose">確定</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
	data() {
		return {
			visibleSuccess: false,
			ruleForm: {
				password: "",
				passwordConfirm: ""
			},
			rules: {
				password: [
					{
						required: true,
						message: "請輸入新密碼（至少8字元）",
						trigger: "blur"
					},
					{ min: 8, message: "長度至少為8字元", trigger: "blur" }
				],
				passwordConfirm: [
					{ required: true, message: "再次輸入密碼", trigger: "blur" },
					{ validator: this.checkPassword, trigger: "blur" }
				]
			}
		};
	},
	computed: {
		...mapState("user", ["userInfo"])
	},
	methods: {
		...mapActions(["logout"]),
		...mapActions("user", [
			"changePassword",
			"cleanToken",
			"setAPIToken"
		]),
		checkPassword(rule, value, callback) {
			if (this.ruleForm.password != value) {
				callback(new Error("兩次密碼不相同"));
			}
			callback();
		},
		changePasswordSumbit() {
			this.$refs["changePwdForm"].validate(async valid => {
				if (valid) {
					let data = {
						password: this.ruleForm.password
					};
					try {
						await this.changePassword(data);
						this.visibleSuccess = true;
					} catch (e) {
						console.log(e);
						this.$message.error(e);
					}
				} else {
					this.$message.error("資料未填寫正確");
				}
			});
		},
		handleClose() {
			this.visibleSuccess = false;
			this.logout();
		},
		async handleToken() {
			let token = ""
			if (this.$route.query.token) {
				token = this.$route.query.token;
			} else if (localStorage.getItem("token")) {
				token = localStorage.getItem("token");
			}
			await this.cleanToken();
			await this.setAPIToken(token);
		}
	},
	created() {
		this.handleToken();
	},
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.change-password {
	padding-bottom: 20px;
}

h1 {
	margin-bottom: 35px;
}
.el-form {
	width: 360px;
}
.el-input {
	width: 100%;
}
.el-button {
	width: 100%;
}
.confirm-btn {
	border: solid 1px #cacfd4;
}

.description {
	font-size: 18px;
}

.success-button {
	width: 150px;
	height: 30px;
}
</style>